@import 'styles/mixins';
@import 'styles/variables';

.root {
  & > * {
    [data-design-system='blaze'] & {
      opacity: 1;
      @include focus-mode-transition;
    }
  }

  &.hidden {
    & > * {
      [data-design-system='blaze'] & {
        opacity: 0;
      }
    }
  }
}
